import * as React from 'react';
import { useIntl } from 'react-intl';

import { CountryCode } from '../../api-types/common';
import { getCountryMessageId } from '../../utils/localizedMessages';

type Props = {
  countryCode: CountryCode;
};

export const LocalizedCountry: React.FC<Props> = ({ countryCode }) => {
  const { formatMessage } = useIntl();

  return (
    <>{formatMessage({ id: getCountryMessageId(countryCode), defaultMessage: countryCode })}</>
  );
};
